<template>
  <div>
    <!-- <div class="mb-4">
      <Link class="group flex items-center py-3" href="/">
        <TvIcon class="mr-2 w-5 h-5" :class="isUrl('') ? 'text-white' : 'text-indigo-400 group-hover:text-white'" />
        <div class="moul" :class="isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">ទំព័រដើម</div>
      </Link>
    </div> -->
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/loans">
        <CurrencyDollarIcon class="mr-2 w-5 h-5" :class="isUrl('loans') || isUrl('') ? 'text-white' : 'text-indigo-400 group-hover:text-white'" />
        <div class="moul" :class="isUrl('loans') || isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">កម្ចី</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/repays">
        <BanknotesIcon class="mr-2 w-5 h-5" :class="isUrl('repays') ? 'text-white' : 'text-indigo-400 group-hover:text-white'" />
        <div class="moul" :class="isUrl('repays') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">បង់ប្រាក់</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/repay-lists">
        <QueueListIcon class="mr-2 w-5 h-5" :class="isUrl('repay-lists') ? 'text-white' : 'text-indigo-400 group-hover:text-white'" />
        <div class="moul" :class="isUrl('repay-lists') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">បញ្ជីបង់ប្រាក់</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/contacts">
        <UserGroupIcon class="mr-2 w-5 h-5" :class="isUrl('contacts') ? 'text-white' : 'text-indigo-400 group-hover:text-white'" />
        <div class="moul" :class="isUrl('contacts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">អតិថិជន</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/users">
        <UsersIcon class="mr-2 w-5 h-5" :class="isUrl('users') ? 'text-white' : 'text-indigo-400 group-hover:text-white'" />
        <div class="moul" :class="isUrl('users') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">បុគ្គលិក</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/reports">
        <PresentationChartLineIcon class="mr-2 w-5 h-5" :class="isUrl('reports') ? 'text-white' : 'text-indigo-400 group-hover:text-white'" />
        <div class="moul" :class="isUrl('reports') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">របាយការណ៍</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/settings">
        <CogIcon class="mr-2 w-5 h-5" :class="isUrl('settings') ? 'text-white' : 'text-indigo-400 group-hover:text-white'" />
        <div class="moul" :class="isUrl('settings') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">ការកំណត់</div>
      </Link>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import { TvIcon, ClipboardDocumentListIcon, PresentationChartLineIcon, UsersIcon, UserGroupIcon, CurrencyDollarIcon, BanknotesIcon, CogIcon, QueueListIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    TvIcon,
    ClipboardDocumentListIcon,
    PresentationChartLineIcon,
    UsersIcon,
    UserGroupIcon,
    CurrencyDollarIcon,
    BanknotesIcon,
    CogIcon,
    QueueListIcon,
    Link,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
